var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStormDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 204 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_303_723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.8259 41.0872C92.8629 40.8674 92.8822 40.6412 92.8822 40.4103C92.8822 38.2507 91.1922 36.5 89.1074 36.5C87.5576 36.5 86.2259 37.4676 85.6446 38.8514C85.1736 38.4302 84.5625 38.1759 83.8946 38.1759C82.4055 38.1759 81.1983 39.4403 81.1983 41C81.1983 41.0869 81.2021 41.1728 81.2094 41.2576C80.4932 41.6211 80 42.3836 80 43.2655C80 44.4996 80.9657 45.5 82.157 45.5H92.343C93.5343 45.5 94.5 44.4996 94.5 43.2655C94.5 42.2034 93.7847 41.3144 92.8259 41.0872Z",
    fill: "url(#paint0_linear_303_723)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_303_723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.88 65.3781C128.048 64.4253 128.136 63.4452 128.136 62.4448C128.136 53.0865 120.444 45.5 110.955 45.5C103.9 45.5 97.8386 49.6928 95.1925 55.6894C93.0488 53.8641 90.2671 52.7621 87.2273 52.7621C80.4492 52.7621 74.9545 58.2412 74.9545 65C74.9545 65.3764 74.9716 65.7488 75.0049 66.1165C71.7448 67.6913 69.5 70.9957 69.5 74.8172C69.5 80.1649 73.8957 84.5 79.3182 84.5H125.682C131.104 84.5 135.5 80.1649 135.5 74.8172C135.5 70.2148 132.244 66.3624 127.88 65.3781Z",
    fill: "url(#paint1_linear_303_723)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_303_723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.091 40.5138C138.091 41.1935 138.032 41.8595 137.92 42.5069C140.829 43.1757 143 45.7934 143 48.9207C143 52.5543 140.07 55.5 136.455 55.5H126.632C123.942 49.6047 117.935 45.5 110.955 45.5C106.366 45.5 102.198 47.2736 99.1166 50.1635C99.0401 49.761 99 49.3456 99 48.9207C99 46.324 100.497 44.0787 102.67 43.0086C102.648 42.7588 102.636 42.5057 102.636 42.25C102.636 37.6575 106.299 33.9345 110.818 33.9345C112.845 33.9345 114.699 34.6833 116.128 35.9236C117.892 31.8489 121.933 29 126.636 29C132.963 29 138.091 34.1549 138.091 40.5138Z",
    fill: "url(#paint2_linear_303_723)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_303_723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.4934 95.5C88.9316 98.8605 85.3451 105.582 91.4934 105.582C97.6418 105.582 94.0552 98.8605 91.4934 95.5Z",
    fill: "#507CB1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_303_723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8948 87.5C96.333 90.8605 92.7465 97.5815 98.8948 97.5815C105.043 97.5815 101.457 90.8605 98.8948 87.5Z",
    fill: "#507CB1"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_303_723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3948 87.5C80.833 90.8605 77.2465 97.5815 83.3948 97.5815C89.5431 97.5815 85.9566 90.8605 83.3948 87.5Z",
    fill: "#507CB1"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_303_723)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.3181,
    y: 81.9456,
    width: 49.379,
    height: 7.2011,
    rx: 3.60055,
    fill: "#FFED8D"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_303_723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.315 84.5H111.54L107.29 95.8413H114.94L111.398 110L124.29 91.4249H118.623L121.315 84.5Z",
    fill: "url(#paint3_linear_303_723)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_303_723",
    x: 80,
    y: 36.5,
    width: 14.5,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_723"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_303_723",
    x: 69.5,
    y: 45.5,
    width: 66,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_723"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_303_723",
    x: 99,
    y: 29,
    width: 44,
    height: 36.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_723"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_303_723",
    x: 88.0986,
    y: 95.5,
    width: 6.78955,
    height: 13.0815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_723"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_303_723",
    x: 95.5,
    y: 87.5,
    width: 6.78955,
    height: 13.0815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_723"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_303_723",
    x: 80,
    y: 87.5,
    width: 6.78955,
    height: 13.0815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_723"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_303_723",
    x: 0.318115,
    y: 4.94556,
    width: 203.379,
    height: 161.201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.5,
    result: "effect1_foregroundBlur_303_723"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_303_723",
    x: 105.29,
    y: 84.5,
    width: 19,
    height: 25.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_723"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_723",
    x1: 80.9223,
    y1: 44.6964,
    x2: 96.0118,
    y2: 33.9041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_303_723",
    x1: 73.6979,
    y1: 81.0179,
    x2: 140.06,
    y2: 31.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_303_723",
    x1: 140.201,
    y1: 53.1339,
    x2: 95.3549,
    y2: 20.0779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_303_723",
    x1: 113.688,
    y1: 107.544,
    x2: 130.106,
    y2: 84.7064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormDay);
export default __webpack_public_path__ + "static/media/Storm_Day.d7650d0d506529f6c8e83488a95ad7c6.svg";
export { ForwardRef as ReactComponent };